import { postRequest } from '@/core';
import { deviations } from '@/requests';

export default async function deviationSearchRequest(filter) {
	let url = deviations.getSearchPath();
	return postRequest(url, {}, filter);
}